const campaignMapping: Record<string, string> = {
  '19971383209': 'Hors IDF - Séminaire (FR)',
  '18797295030': 'Île-de-France - Séminaire (FR)',
  '23010370708': 'Île-de-France - Soirée d\'entreprise (FR)',
  '23072080443': 'Séminaire international (FR)',
  '23164454832': 'France - Séminaire au ski (FR)'
};

export function getCampaignName(urlParams: URLSearchParams, storedUTMs?: Record<string, string>): string {
  // Try to get campaign ID from hsa_cam or gad_campaignid
  const campaignId = urlParams.get('hsa_cam') || urlParams.get('gad_campaignid') || storedUTMs?.hsa_cam || storedUTMs?.gad_campaignid;
  
  if (campaignId && campaignMapping[campaignId]) {
    return campaignMapping[campaignId];
  }
  
  // Fallback to utm_campaign if campaign ID not found
  const utmCampaign = urlParams.get('utm_campaign') || storedUTMs?.utm_campaign;
  if (utmCampaign) {
    return decodeURIComponent(utmCampaign);
  }
  
  return '';
}
